// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BackToListButton_button__RTYfs {
  border-radius: 50%;
  width: 36px;
  height: 36px;
  background-color: #f1f1f1;
  color: #454545;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
}
.BackToListButton_button__RTYfs:hover {
  background-color: lightgray;
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/components/Misc/BackToListButton.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,gBAAA;AAAF;AAEE;EACE,2BAAA;EACA,YAAA;AAAJ","sourcesContent":[".button {\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  background-color: #f1f1f1;\n  color: #454545;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: 0.2s;\n}\n.button:hover {\n  background-color: lightgray;\n  color: black;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `BackToListButton_button__RTYfs`
};
export default ___CSS_LOADER_EXPORT___;
